import type { SxProps, Theme } from '@mui/material';

import { IllustrationWrapper } from '../IllustrationWrapper';

import { WelcomingIllustration } from './Welcoming';

interface Props {
  readonly sx?: SxProps<Theme>;
  readonly title?: string;
}

export const Welcoming = ({ sx, title }: Readonly<Props>) => (
  <IllustrationWrapper sx={sx}>
    <WelcomingIllustration title={title} />
  </IllustrationWrapper>
);
